import getClient from './_get-client';

const screenerApiClient = async ({ baseUrl, baseAuthUrl, yyy }) => {
  const apiClient = await getClient({ baseUrl, baseAuthUrl, yyy });
  return apiClient;
};

export default screenerApiClient;
